import { useState } from "react";
import { DollarSign } from "lucide-react";
import { fmtCurrency } from "@/lib/format";

const SPANS = [["today", "Today"], ["week", "This Week"]];

export const BilledMonthCard = ({ revenue }) => (
  <div className="bg-white border border-slate-200 rounded-xl p-5 shadow-sm" data-testid="rev-this-month">
    <div className="flex items-center justify-between">
      <span className="text-xs uppercase tracking-wider text-slate-400 font-semibold">Billed This Month</span>
      <DollarSign className="h-4 w-4 text-cyan-500" />
    </div>
    <div data-testid="rev-this-month-billed" className="mt-2 font-mono-metric text-2xl font-bold text-slate-900">{fmtCurrency(revenue?.month_revenue || 0)}</div>
    <div data-testid="rev-this-month-collected" className="text-xs text-slate-500 mt-1">{fmtCurrency(revenue?.month_collected || 0)} collected</div>
  </div>
);

export const BilledQuickCard = ({ revenue }) => {
  const [span, setSpan] = useState("week");
  const q = revenue?.quick?.[span] || { billed: 0, collected: 0 };
  const label = SPANS.find((s) => s[0] === span)[1];
  return (
    <div className="bg-white border border-slate-200 rounded-xl p-5 shadow-sm" data-testid="rev-month">
      <div className="flex items-center justify-between gap-2">
        <span data-testid="rev-quick-label" className="text-xs uppercase tracking-wider text-slate-400 font-semibold">Billed {label}</span>
        <DollarSign className="h-4 w-4 text-cyan-500" />
      </div>
      <div className="flex gap-1 mt-2" role="group">
        {SPANS.map(([k, l]) => (
          <button key={k} data-testid={`rev-quick-${k}`} onClick={() => setSpan(k)}
            className={`px-2 py-0.5 rounded-full text-[11px] font-semibold transition-colors ${span === k ? "bg-[#0B1F44] text-white" : "bg-slate-100 text-slate-500 hover:bg-slate-200"}`}>
            {l}
          </button>
        ))}
      </div>
      <div data-testid="rev-quick-billed" className="mt-2 font-mono-metric text-2xl font-bold text-slate-900">{fmtCurrency(q.billed)}</div>
      <div data-testid="rev-month-collected" className="text-xs text-slate-500 mt-1">
        {fmtCurrency(q.collected)} collected{q.since ? ` · since ${new Date(`${q.since}T12:00:00`).toLocaleDateString("en-US", { month: "short", day: "numeric" })}` : ""}
      </div>
    </div>
  );
};
